import { render, staticRenderFns } from "./activitypackagecoursedetails.vue?vue&type=template&id=eefff7ae&scoped=true"
import script from "./activitypackagecoursedetails.vue?vue&type=script&lang=js"
export * from "./activitypackagecoursedetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eefff7ae",
  null
  
)

export default component.exports